import React from 'react'
import { T, useT } from '@transifex/react'
import { FEATURE_UC_IN_WEBREGISTER_NOTE_INPUT } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { NoteField } from '../../../../shared/NoteField'
import { NOTE_MAX_CHAR } from '../../../../../models/fulfilment'
import { useAppDispatch } from '../../../../../state/hooks'
import {
  FulfilmentNoteEntryLocation,
  setFulfilmentNoteEntryLocation,
} from '../../../../../state/slices/uiStateSlice'
import { LineItemFulfilmentNoteProps } from './useLineItemFulfilmentNoteModel'
import { LineItemFulfilmentNoteLegacy } from './LineItemFulfilmentNoteLegacy'

export const TContext = 'Line item fulfilment tab'

type Props = LineItemFulfilmentNoteProps & {
  /** Which UI surface this instance is rendered in — the "Choose how it
   * will be fulfilled" popover, the sale sidebar's Fulfillment tab, or the
   * "Mark as unfulfilled" modal. Recorded so the "Fulfillment Note" UBE can
   * report where merchants use this feature from. */
  source: FulfilmentNoteEntryLocation
}

export const LineItemFulfilmentNote: React.FC<Props> = ({
  source,
  onChange,
  ...props
}) => {
  const t = useT()
  const dispatch = useAppDispatch()
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_NOTE_INPUT
  )

  const handleChange = (note: string) => {
    dispatch(setFulfilmentNoteEntryLocation(source))
    onChange(note)
  }

  if (!isUnifiedEnabled) {
    return <LineItemFulfilmentNoteLegacy {...props} onChange={handleChange} />
  }

  return (
    <NoteField
      value={props.note}
      charLimit={NOTE_MAX_CHAR}
      label={<T _str="Fulfillment Note" _context={TContext} />}
      descriptionSlot={
        <T
          _str="Items that require fulfillment share this note"
          _context={TContext}
        />
      }
      placeholder={t('Enter a fulfillment note', { _context: TContext })}
      disabled={props.isDisabled}
      onChange={handleChange}
      onErrorsChange={props.onErrorsChange}
    />
  )
}

export type { LineItemFulfilmentNoteProps } from './useLineItemFulfilmentNoteModel'
